<div class="mt-1 flex flex-col sm:mt-0 sm:flex-row sm:flex-wrap sm:space-x-6">
	<p class="max-w-xl text-sm text-gray-500 2xl:max-w-3xl">
		<ng-content />
	</p>
</div>
